import React from "react";
import classNames from "classnames/bind";
import styles from "../ProfilePage.module.scss";
import { User, Package, LogOut } from "lucide-react";

const cx = classNames.bind(styles);

const Sidebar = ({
  user,
  formData,
  activeTab,
  setActiveTab,
  handleLogout,
  currentTranslations,
}) => {
  return (
    <div className={cx("sidebar")}>
      <div className={cx("user-info")}>
        <div className={cx("avatar")}>
          <User size={40} />
        </div>
        <h3 className={cx("user-name")}>
          {user?.display_name ||
            `${formData.firstName} ${formData.lastName}`}
        </h3>
        <p className={cx("user-email")}>{user?.email}</p>
      </div>

      <nav className={cx("nav-menu")}>
        <button
          className={cx("nav-item", { active: activeTab === "profile" })}
          onClick={() => setActiveTab("profile")}
        >
          <User size={18} />
          {currentTranslations?.Profile?.personal_info}
        </button>
        <button
          className={cx("nav-item", { active: activeTab === "orders" })}
          onClick={() => setActiveTab("orders")}
        >
          <Package size={18} />
          {currentTranslations?.Profile?.my_orders}
        </button>
        <button
          className={cx("nav-item", "logout-btn")}
          onClick={handleLogout}
        >
          <LogOut size={18} />
          {currentTranslations?.Profile?.logout}
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;
